import script from "./TitleWithButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleWithButton.vue?vue&type=script&setup=true&lang=js"

import "./TitleWithButton.vue?vue&type=style&index=0&id=5692e3ae&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5692e3ae"]])

export default __exports__